export default {
  dark: 'Buio',
  light: 'Leggero',
};
